import {
    FeedbackAnswerQualityRatingEnum,
    FeedbackAnswerWrongRatingEnum,
    FeedbackCategoryEnum,
    FeedbackQuestion,
    FeedbackRelatedQuestionsRatingEnum,
} from '../types';

export const ActionButtonRendererConstants = {
    DATA_CY_ACTION_BUTTONS: 'data-cy-action-buttons',
};

export const ChatContentConstants = {
    CANVAS_CHAT_SLOT: 'chat',
    CANVAS_IMPORTANT_INFO_SLOT: 'important-information',
    CHAT_BUBBLE_CONTENT_SLOT: 'content',
    CONTACT_RM_SLOT: 'contact-rm',
    CONTENT_SLOT: 'content',
    TARGET_SLOT: 'target',
    OVERLAY_SLOT: 'overlay',
};

export const ContactCardConstants = {
    DATA_CY_CONTACT_CARD: 'data-cy-contact-card',
    BXF_CONTACT_ICON: 'bxf-contact',
};

export const activeContentPages = {
    CHAT: 'chat',
    IMPORTANT_INFO: 'important-information',
    LOADING: 'loading',
    LOADING_ERROR: 'loading-error',
    UNVERIFIED: 'unverified-advisor',
    ERROR: 'error',
    LOGIN: 'login',
    CONTACT_RM: 'contact-rm',
    RECENT: 'recent',
};

export const ChatFrameConstants = {
    CHAT_SCROLL_CONTAINER: '.bxf-chat-canvas__chat-container--scroll',
    MASTHEAD_WRAPPER: 'mastheadWrapper',
    CHAT_CANVAS_WRAPPER: 'chat-canvas-wrapper',
    BLK_AC_HEADER: 'blk-ac-header',
    SMALL_SCREEN_MAX_WIDTH: 1024,
    SMALL_SCREEN_HEADER_HEIGHT: 60,
    DATA_CY_CHAT_CANVAS: 'data-cy-chat-canvas',
    CANVAS_DISMISS_ASSISTIVE_TEXT: 'Dismiss',
    CANVAS_NEW_CHAT_ASSISTIVE_TEXT: 'Reset',
    CANVAS_FULL_SCREEN_ASSISTIVE_TEXT: 'Fullscreen',
    CANVAS_EXIT_FULL_SCREEN_ASSISTIVE_TEXT: 'Exit Fullscreen',
    CANVAS_RECENT_ASSISTIVE_TEXT: 'Recent prompts',
    CANVAS_CONTACT_RM_ASSISTIVE_TEXT: 'Your contact',
};

export const ChatExchangeConstants = {
    USER_QUERY: 'chat-exchange__user-query',
    USER_BUBBLE_CONTENT_SLOT: 'content',
    CONTENT_SLOT: 'content',
    TARGET_SLOT: 'target',
};

export const ChatFooterConstants = {
    LINK_LABEL_LEARN_MORE: 'Learn More',
    LINK_LABEL_TERMS_OF_USE: 'Terms of Use',
    LINK_LABEL_IMPORTANT_INFO: 'Important Info',
    LINK_LABEL_PRIVACY_NOTICE: 'Privacy Notice',
    CHAT_PROMPT_BOX_DISCLAIMER_SLOT: 'disclaimer',
    CHAT_CANVAS_FOOTER_SLOT: 'footer',
    DATA_CY_CHAT_PROMPT_BOX: 'data-cy-chat-prompt-box',
    LEARN_MORE_LINK:
        'https://www.blackrock.com/us/financial-professionals/chatblk-learn-more',
    TERMS_OF_USE_LINK:
        'https://www.blackrock.com/us/financial-professionals/compliance/advisor-terms-of-use',
    PRIVACY_NOTICE_LINK:
        'https://www.blackrock.com/corporate/compliance/privacy-policy',
    PROMPT_BOX_MAX_HEIGHT: 104,
    PROMPT_BOX_MAX_CHARS: 500,
};

export const ResetDialogConstants = {
    CAUTION_ICON: 'bxf-caution',
    DIALOG_HEADER: 'Warning',
    DIALOG_TYPE: 'prompt',
    DATA_CY_RESET_DIALOG: 'data-cy-reset-dialog',
};

export const SourceListConstants = {
    DATA_CY_SOURCE_LIST: 'data-cy-source-list',
    SOURCES_SLOT: 'sources',
};

export const MarkdownRendererConstants = {
    BXF_LINK_TARGET_BLANK: '_blank',
};

export const CaptureFeedbackConstants = {
    FEEDBACK_CONSTANTS: {
        rating: {
            question: 'Please rate the quality of the ANSWER',
            values: [
                'Not at all accurate',
                'Not very accurate',
                'Somewhat accurate',
                'Very accurate',
                'Extremely accurate',
            ],
        },
        checkbox: {
            question: 'What was wrong with the ANSWER?',
            values: [
                'Too short',
                'Poor source(s)',
                'Off topic',
                'Red teaming',
                'Confusing',
                'Out of date',
                'Hallucination',
                'Too long',
                'Incomplete',
                'Ground truth',
                'Other (use form below)',
            ],
        },
        comment: {
            question: 'Other Feedback / Source URLs',
            placeholder:
                'Enter feedback here or provide correct and/or additional source URL links',
        },
        rewrite: {
            question: 'Rewrite response to train ChatBLK',
            placeholder:
                'Rewrite how ChatBLK should respond to the prompt asked to help train the bot',
        },
    },
    DATA_CY_FEEDBACK: 'data-cy-capture-feedback',
    DATA_CY_CHECKBOX_GROUP: 'data-cy-checkbox-group',
    DEFAULT_PLACEHOLDER: 'Enter text here',
    CATEGORIES: {
        RATING: 'answerRating',
        CHECKBOX: 'feedbackCategories',
        COMMENT: 'feedbackComment',
        REWRITE: 'feedbackRewrite',
    },
    QUESTION_CATEGORIES: Object.values(FeedbackCategoryEnum),
    ANSWER_QUALITY_RATINGS: Object.values(FeedbackAnswerQualityRatingEnum),
    ANSWER_WRONG_RATINGS: Object.values(FeedbackAnswerWrongRatingEnum),
    RELATED_QUESTIONS_RATINGS: Object.values(
        FeedbackRelatedQuestionsRatingEnum
    ),
    CHECKBOX_GROUP_DATA: Object.values(FeedbackAnswerWrongRatingEnum).map(
        (rating: string, index: number) => {
            const i = index + 1;
            return {
                uid: `${i}`,
                label: rating,
                disabled: false,
                isSecondaryLabelRight: false,
            };
        }
    ),
    CHATBLK_FEEDBACK_QUESTIONS: {
        answerRating: {
            question: 'Please rate the quality of the ANSWER:',
            type: 1,
            answer: '',
        },
        feedbackCategories: {
            question: 'What was wrong with the ANSWER?',
            type: 2,
            answer: '',
            answers: [],
        },
        feedbackComment: {
            question: 'Other Feedback / Source URLs',
            placeholderText:
                'Enter feedback here or provide correct and/or additional source URL links',
            type: 3,
            answer: '',
        },
        feedbackRewrite: {
            question: 'Rewrite response to train ChatBLK',
            placeholderText:
                'Rewrite how ChatBLK should respond to the prompt asked to help train the bot',
            type: 4,
            answer: '',
        },
    } as { [key: string]: FeedbackQuestion },
    NON_PROD_FEEDBACK_QUESTIONS_LENGTH: 4,
    PROD_FEEDBACK_QUESTIONS_LENGTH: 1,
    SLOT_CONTENT: 'content',
    PRESENTATION: 'presentation',
    SUBMIT: 'Submit',
    ASTERISK: '*',
    FEEDBACK_SLOT: 'feedback',
};

export const ServerMessageConstants = {
    DATA_CY_SERVER_CHAT_BUBBLE: 'data-cy-server-chat-bubble',
};

export const InfoPopoverConstants = {
    INFO_POPOVER_TARGET: 'target',
    INFO_POPOVER_CONTENT: 'content',
    DATA_CY_INFO_POPOVER_CONTENT: 'data-cy-info-popover-content',
    DATA_CY_INFO_POPOVER_TARGET: 'data-cy-info-popover-target',
};

export const SourcePopoverConstants = {
    SOURCE_POPOVER_TARGET: 'target',
    SOURCE_POPOVER_CONTENT: 'content',
    DATA_CY_SOURCE_POPOVER_CONTENT: 'data-cy-source-popover-content',
    DATA_CY_SOURCE_POPOVER_TARGET: 'data-cy-source-popover-target',
};

export default {
    ChatContentConstants,
    ChatFrameConstants,
    ChatExchangeConstants,
    ChatFooterConstants,
    ResetDialogConstants,
    CaptureFeedbackConstants,
    ServerMessageConstants,
};
